import React, { useState } from "react";
import BrandWhite from "../assets/72.svg";
import { Link } from "react-router-dom";
import { useModal } from "../context/ModalContext";
import { useAPI } from "../hooks/useAPI";

const Footer = () => {
  const { openModal } = useModal();
  const { api } = useAPI();
  const [email, setEmail] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    try {
      // TODO: Replace with your actual API endpoint
      const response = await api.post("/api/newsletters/subscribe", { email });

      if (response?.status === 200) {
        setSubscriptionStatus("success");
        setEmail("");
      } else {
        setSubscriptionStatus("error");
      }
    } catch (error) {
      console.error("Error subscribing to newsletter:", error);
      if (error?.response?.data?.message === "Email already subscribed") {
        setSubscriptionStatus("Email already subscribed");
      } else {
        setSubscriptionStatus("error");
      }
    }
  };

  return (
    <>
      <div className="cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cta-caption">
              <h2>
                <i>Join us</i> in making roads safer.
              </h2>
            </div>
            <div className="cta-button">
              <button onClick={openModal}>
                Get in touch <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-main-section">
        <div className="container w-100">
          <div className="row w-100">
            <div className="col col-12 col-md-7">
              <div className="row">
                <div className="col col-12 col-md-4 mb-4">
                  <div className="brand mb-5">
                    {/* <h1>shoora</h1> */}
                    <img src={BrandWhite} alt="Shoora" width={130} />
                  </div>
                  <div className="footer-social-container">
                    <ul className="footer-social-group">
                      <li className="footer-social-item">
                        <Link
                          to="https://www.facebook.com/profile.php?id=61566543857192"
                          target="_blank"
                        >
                          <i className="fa-brands fa-square-facebook"></i>
                        </Link>
                      </li>
                      <li className="footer-social-item">
                        <Link
                          to="https://x.com/techshoora?s=11"
                          target="_blank"
                        >
                          <i className="fa-brands fa-square-x-twitter"></i>
                        </Link>
                      </li>
                      <li className="footer-social-item">
                        <Link
                          to="https://www.linkedin.com/company/shooratechnologies/"
                          target="_blank"
                        >
                          <i className="fa-brands fa-linkedin"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col col-12 col-md-8">
                  <div className="footer-links-container">
                    <h5 className=" mb-4">NEWSROOM</h5>
                    <p className=" mb-4 w-75 lh-1">
                      Get the latest news and updates about Shoora.{" "}
                    </p>
                    <Link className="footer-btn" to="/newsroom">
                      Visit the newsroom{" "}
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
                  <div className="newsletter-container mt-4">
                    <h5 className="mb-3">NEWSLETTER</h5>
                    <p className="mb-3">
                      Stay updated with our latest news and updates.
                    </p>
                    <form
                      className="newsletter-form"
                      onSubmit={handleNewsletterSubmit}
                    >
                      <div className="input-group mb-3">
                        <input
                          type="email"
                          className="form-control w-100"
                          placeholder="Your email address"
                          aria-label="Email address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                        <button className="btn btn-primary" type="submit">
                          Subscribe
                        </button>
                      </div>
                      {subscriptionStatus === "success" && (
                        <div className="alert alert-success mt-2">
                          Thank you for subscribing to our newsletter!,
                          Verification email has been sent to yor email, Please
                          verify.
                        </div>
                      )}
                      {subscriptionStatus === "error" && (
                        <div className="alert alert-danger mt-2">
                          There was an error subscribing. Please try again
                          later.
                        </div>
                      )}
                      {subscriptionStatus === "Email already subscribed" && (
                        <div className="alert alert-warning mt-2">
                          Your email is already subscribed for recieving all
                          future newsletters.
                        </div>
                      )}
                    </form>
                  </div>
                </div>
                <div className="col col-3"></div>
              </div>
            </div>
            <div className="col col-12 col-md-5">
              <div className="row">
                <div className="col">
                  <div className="footer-links-container">
                    <h5>OUR LOCATIONS</h5>
                    <ul className="footer-links-group">
                      <li className="footer-link-item">
                        <Link to="/contact">India</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/contact">Dubai</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/contact">Tanzania </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col">
                  <div className="footer-links-container">
                    <h5>Useful Links</h5>
                    <ul className="footer-links-group">
                      <li className="footer-link-item">
                        <Link to="/about">About Shoora</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/solutions">Solutions</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/insights">Insights</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/careers">Careers</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/contact">Contact us</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-info-section">
        <div className="container">
          <div className="footer-info-container d-flex justify-content-between w-100">
            <Link className="copyright">2024 SHOORA. ALL RIGHTS RESERVED</Link>
            <div className="d-flex footer-info-container">
              <Link to="/legal/privacy-policy">Privacy Policy</Link>
              <Link to="/legal/terms-of-use">Terms of Use</Link>
              {/* <Link >Cookie Settings</Link> */}
              <Link to="/legal/accessibility-statement">
                Accessibility Statement
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
